import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-support-table',
  templateUrl: './browser-support-table.component.html',
  styleUrls: ['./browser-support-table.component.scss']
})
export class BrowserSupportTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/browser-support-table/browser-support-table.component.ts